import React,{ useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import {
    Container,
    ScreenClassRender
} from "react-grid-system";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import GenericUpper from "../../components/generic-upper";
import Select from "../../components/select/select_v2";
import Input from "../../components/input/input_v2";
import Button  from '../../components/button/button_v2';
import Modal from "../../components/modal";
import { store } from "react-notifications-component";

import PeapleWarning from '../../assets/undraw-warning.svg';

import * as S from './styles'
import { UserContainer } from "./styles";
import { theme } from "../../styles/theme";
import { BodyG, H5 } from "../../styles/stylesTypography";
import { use } from "react";
import { isTotvs } from "../../services/globalFunctions";

export const USER = "@userinfo";

const EditUsuario = ({...props}) => {
    const [width, setWidth] = useState(window.innerWidth);

    const [user, setUserData] = useState({});

    const [permissoes, setPermissoes] = useState([])
    const [lojas, setLojas] = useState([]);
    const [permissaoId, setPermissaoId] = useState('');
    const [email, setEmail] = useState('');
    const [enviar_receita, setEnviarReceita] = useState('');
    const [nome, setNome] = useState('');
    const [lojaId, setLojaId] = useState('');
    const [opStatus] = useState([
        { value: "AT", label: "Ativo" },
        { value: "IN", label: "Inativo" }
    ]);
    const [disabledUserInativo, setDisabledUserInativo] = useState(false);
    const [status, setStatus] = useState('');
    const [userId, setUserId] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [paramPost, setParamPost] = useState(false);

    const [loading, setLoading] = useState(false);

    const [erroNome, setErroNome] = useState(false);
    const [erroEmail, setErroEmail] = useState(false);
    const [erroPermissao, setErroPermissao] = useState(false);
    const [erroLoja, setErroLoja] = useState(false);
    const [erroStatus, setErroStatus] = useState(false);
    const [erroWhatsapp, setErroWhatsapp] = useState(false);

    const [openModalAlert, setOpenModalAlert] = useState(false);
    const [mensagemModalAlert, setMensagemModalAlert] = useState('');

    const [userPlanId, setUserPlanId] = useState('');


    const formatFiliais = useCallback((filiais) => {
        return (filiais || []).map(f => ({ value: f.id, label: f.nome_fantasia }));
    }, []);

    const getFiliais = useCallback(async () => {
        try {
            const response = await api.get("/filiais");
            const filiais = response.data.data;

            if (filiais && filiais.length > 0) {
                let filialFormat = formatFiliais(filiais);
                setLojas(filialFormat);

            } else {
                setLojas([]);
                store.addNotification({
                    title: "Atenção!",
                    message: "Nenhuma filial encontrada",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } catch (e) {
        }
    }, [formatFiliais]);

    const getPermission = useCallback(async () => {
        const response = await api.get(`/users/nivel/permissao`);

        const niveis = response.data.data.nivel[0];

        const descricoesPermissao = {
            1: 'Acesso total ao sistema.',
            2: 'Acesso restrito à sua filial.',
            3: 'Acesso operacional. Focado na emissão de receitas e consulta de solicitações. Visualiza apenas os dados da própria filial.',
        };

        const permissoesFormatadas = Object.entries(niveis).map(([key, value]) => ({
            value: Number(key),
            label: value,
            description: descricoesPermissao[Number(key)] || undefined,
        }));

        setPermissoes(permissoesFormatadas);
    }, []);


    const validatePermissao = async (permissao) => {
        setPermissaoId(permissao.value);
    }

    const validateNome = async (nome) => {
        setNome(nome);
    }

    const validateEmail = async (email) => {
        setEmail(email);
    }

    const validateLoja = async (loja) => {
        setLojaId(loja.value);
    }

    const validateStatus = async (status) => {
        setStatus(status.value);
        if (status.value === "AT" && disabledUserInativo === true) {
            setDisabledUserInativo(false);
        }
    }

    const validateWhatsapp = async (whatsapp) => {
        setWhatsapp(whatsapp);

        setErroWhatsapp(false);
    }

    const validarCampos = () => {
        setErroNome(!nome);
        setErroEmail(!email);
        setErroPermissao(!permissaoId);
        setErroLoja(!lojaId);
        setErroStatus(!status);
        
        const whatsappValido = !whatsapp || whatsapp.length === 13 || whatsapp.length === 14;
        setErroWhatsapp(!whatsappValido);

        return !nome || !email || !permissaoId || !lojaId || !status || !whatsappValido;
    }

    const salvarUser = async () => {
        try {
            setLoading(true);
            
            const Erro = validarCampos();
            
            if (Erro) {
                setLoading(false);
                store.addNotification({
                    title: "Erro!",
                    message: "Preencha todos os campos obrigatórios",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                return;
            }

            if (paramPost === false) {
                if(lojaId){
                    const payload = {
                        agro_permission_id: permissaoId,
                        username: email,
                        agro_subsidiary_id: lojaId,
                        status: status,
                        name: nome,
                        enviar_receita,
                        whatsapp
                    }
                    await api.put(`/users/${userId}`, payload);
                }else{
                    const payload = {
                        agro_permission_id: permissaoId,
                        username: email,
                        agro_subsidiary_id: '',
                        status: status,
                        name: nome,
                        enviar_receita,
                        whatsapp
                    }

                    await api.put(`/users/${userId}`, payload);
                }
                
            }else{
                if(lojaId){
                    const payload = {
                        agro_permission_id: permissaoId,
                        username: email,
                        agro_subsidiary_id: lojaId,
                        status: status,
                        name: nome,
                        enviar_receita,
                        whatsapp
                    }
                    await api.put(`/users/${userId}`, payload);
                }else{
                    const payload = {
                        agro_permission_id: permissaoId,
                        username: email,
                        agro_subsidiary_id: '',
                        status: status,
                        name: nome,
                        enviar_receita,
                        whatsapp
                    }
                    await api.put(`/users/${userId}`, payload);
                }
            }

            props.history.push('/usuarios');
            setLoading(false);

        } catch (err) {

            setLoading(false);

            const ERRO = err.response.data.errors;
            try {
                let inputWithErrors = document.querySelectorAll(".error");
    
                for (let input of inputWithErrors) {
                    input.classList.remove("error");
                }
    
                const errors = err.response.data.errors;
    
                for (let field in errors) {
                    const input = document.getElementById(field);
                    input.classList.add("error");
                }

                store.addNotification({
                    title: "Erro!",
                    message: `Verifique os campos vermelhos`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                
            } catch (error) {
                if (err.response.status !== 422) {
                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(err, ERRO),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
                
                if (err.response.status === 422) {
                    setOpenModalAlert(true);
                    setMensagemModalAlert(err.response.data.errors);
                    
                    setErroEmail(true);
                }
            }
        }
    }


    const getUsers = async (id) => {
        const response = await api.get(`/users/${id}`);
        
        const users = response.data.data;

        setNome(users.name);
        setPermissaoId(users.agro_permission_id);
        setEmail(users.username);
        setLojaId(users.agro_subsidiary_id);
        setStatus(users.status);
        setEnviarReceita(users.enviar_receita);
        setWhatsapp(users.contacts.whatsapp);

        if (users.status === "IN") {
            setDisabledUserInativo(true);
        } else {
            setParamPost(true);
        }
    } 

    const back = () => {
        window.location = "/usuarios";
    }

    const userIdParam = props.match.params.id;
    const getUserPlan = () => {
        const user = JSON.parse(localStorage.getItem(USER));
        setUserData(user);
        const planId = user.contrato.agro_plan_config.agro_plan_id;
        setUserPlanId(planId);
    }


    useEffect(() => {
        setUserId(userIdParam);
        getFiliais();
        getPermission();
        getUsers(userIdParam);
    }, [userIdParam, getFiliais, getPermission])

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    return(
        <ScreenClassRender
            render={screenClass => (
                <>
                    <GenericUpper
                        title="Editar usuário"
                        subtitle="Gerencie seus usuários"
                    ></GenericUpper>

                    <UserContainer>
                        <Container style={{ width: 'auto', paddingBlock: '20px' }}>
                            <div className="container-center">

                                <Select 
                                    label="Permissão"
                                    labelWithAsterisk={true}
                                    id='permission'
                                    options={permissoes}
                                    value={permissaoId}
                                    onChange={e => {
                                        validatePermissao(e);
                                        setErroPermissao(false);
                                    }}
                                    disabled={disabledUserInativo}
                                    erro={erroPermissao}
                                    marginBottom="42px"
                                    height="auto"
                                />

                                <Input 
                                    label="Nome"
                                    labelWithAsterisk={true}
                                    name="nome"
                                    id="name_id"
                                    value={nome}
                                    onChange={e => {
                                        validateNome(e);
                                        setErroNome(false);
                                    }}
                                    disabled={disabledUserInativo}
                                    erro={erroNome}
                                    marginBottom="8px"
                                    height="auto"
                                />

                                {enviar_receita !== '' && (
                                    <S.ContainerInput>
                                        <Input 
                                            label="Email"
                                            labelWithAsterisk={true}
                                            type="email"
                                            name="email"
                                            id="username"
                                            value={email}
                                            onChange={e => {
                                                validateEmail(e);
                                                setErroEmail(false);
                                            }}
                                            disabled={disabledUserInativo}
                                            yesNo={true}
                                            messageYesNo={'enviar receitas por email'}
                                            onChangeYesNo={(e) => setEnviarReceita(e ? 1 : 0)} 
                                            initialYesNoValue={enviar_receita}
                                            erro={erroEmail}
                                            marginBottom={width <= 990 ? '42px' : '12px'}
                                            height="auto"
                                        />
                                    </S.ContainerInput>
                                )}

                                <Input
                                    name="whatsapp"
                                    value={whatsapp}
                                    type="text"
                                    label="Whatsapp"
                                    labelWithAsterisk={false}
                                    id="whatsapp"
                                    onChange={e => validateWhatsapp(e)}
                                    inputmode="numeric"
                                    erro={erroWhatsapp}
                                    marginBottom="12px"
                                    height="auto"
                                />

                                <Select 
                                    label="Loja"
                                    labelWithAsterisk={true}
                                    id='loja_id'
                                    options={lojas}
                                    value={lojaId}
                                    onChange={e => {
                                        validateLoja(e);
                                        setErroLoja(false);
                                    }}
                                    disabled={disabledUserInativo}
                                    erro={erroLoja}
                                    marginBottom="42px"
                                    height="auto"
                                />

                                <Select 
                                    label="Status"
                                    labelWithAsterisk={true}
                                    id='status_id'
                                    options={opStatus}
                                    value={status}
                                    onChange={e => {
                                        validateStatus(e);
                                        setErroStatus(false);
                                    }}
                                    erro={erroStatus}
                                    marginBottom="42px"
                                    height="auto"
                                />


                                <div 
                                    className="cadastrar" 
                                    id='save'
                                    style={{ 
                                        width: '100%', 
                                        display: 'flex', 
                                        flexDirection: 'row', 
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Button 
                                        width='45%'
                                        height='50px'
                                        value='VOLTAR'
                                        outline={true}
                                        disabled={false}
                                        onClick={() => back()}
                                        loading={false}
                                    />
                                    <Button 
                                        width='45%'
                                        height='50px'
                                        value='SALVAR'
                                        outline={false}
                                        disabled={isTotvs() && user.agro_permission_id !== 4}
                                        onClick={() => salvarUser()}
                                        loading={loading}
                                    />
                                </div>
                            </div>
                        </Container>
                    </UserContainer>

                    {openModalAlert && (
                        <Modal
                            show={openModalAlert}
                            onHide={e => setOpenModalAlert(false)}
                            width='50%'
                        >
                            <S.ContainerWarning>
                                <img src={PeapleWarning} alt="Alerta" />

                                <H5 color={theme.colors.gray.Cinza_5}>E-mail já associado a outra conta</H5>

                                <BodyG color={theme.colors.gray.Cinza_5}>
                                    {mensagemModalAlert}
                                </BodyG>

                                <Button 
                                    width='151px'
                                    height='48px'
                                    value='Entendi'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => setOpenModalAlert(false)}
                                    loading={false}
                                />
                            </S.ContainerWarning>
                        </Modal>
                    )}
                </>
            )}
        />
    )
}

export default EditUsuario;
